module.exports = __webpack_public_path__ + "img/thumb_10.9e7acaef.jpg";